(function ($, Drupal, once) {

  function stripeRows(rows){
    rows.each(function(index){
      $(this).removeClass("odd even");
      $(this).addClass((( index%2===0 )?"even":"odd"));
    });
  }

  function collapsingTable(elems, table) {
    elems.each(function() {
      var target = "." + $(this).attr('id') + "-collapse";
      table.find(target).each(function() {
        $(this).hide();
      });

      $(this).on('click', function() {
        table.find(target).toggle();
        $(this).toggleClass('expanded');
        if ($(this).hasClass('expanded')) {
          $(this).text('close facilities');
        }
        else {
          $(this).text('view facilities');
        }
        stripeRows($("tbody tr:visible:not('.subfacility')"));
      });
    });
  }
        // Single Procedure View
      Drupal.behaviors.procedureView = {
        attach: function (context, settings) {

        once('procedureView', 'html', context).forEach(function(element) {
          let cancerSpecialTrends = $('.view-display-id-trends_chart_cancer_special');
          let mentalHealthTrends = $('.view-display-id-trends_chart_mha');
          if ( cancerSpecialTrends.length > 0 || mentalHealthTrends.length > 0 ) {
            // console.log("mentalHealthTrends bool: " + mentalHealthTrends);
            // console.log("cancerSpecialTrends bool: " + cancerSpecialTrends);
            // console.log("got cancerSpecialTrends or mentalHealthTrends");
            var chartView = cancerSpecialTrends.length > 0 ? cancerSpecialTrends : mentalHealthTrends;
            // console.log("chartView length: " + chartView.length);
            var header = chartView.parents('.waittimes-trends-tab').siblings('.tabs-header');
            // console.log("header length: " + header.length);
            var filter_select = $("<select class='filter_select_special form-control form-item form-select'></select>");
            header.append(filter_select);

            var tableRows = $('.view-display-id-block_6 table tr');
            var options = [];

            let mha = $('article > .category-mha').length !== 0 ?? false;
            if (mha) {
              // If it's a Mental Health procedure, we read the name-value pairs directly out of the table to build the option list.
              tableRows.each(function(){
                let location = $(this).find('.views-field-title span').text().trim() ?? false;
                let type = $(this).find('.views-field-title-1 span').text().trim() ?? false;

                if (location && type) {
                  options.push(location + " - " + type);
                }

              });
            } else {
              // If it's not a Mental Health procedure, we enumerate the types and locations, add Nova Scotia as a location, and write out an option list of all the possible combinations.
              var locations = new Set();
              var types = new Set();

              locations.add("Nova Scotia");
              tableRows.each(function(){
                if ($(this).find('.views-field-title span').text().trim() !== "") {
                  locations.add($(this).find('.views-field-title span').text().trim());
                }

                if ($(this).find('.views-field-title-1 span').text().trim() !== "") {
                  types.add($(this).find('.views-field-title-1 span').text().trim());
                }
              });

              for (const type of types) {
                for (const location of locations) {
                  options.push(location + " - " + type);
                }
              }
            }


            options.sort();

            $.each(options, function(index, value) {
              filter_select.append("<option value='"+value+"'>"+value+"</option>");
            });
            submitDrupalForm();
          }

          function cancerSpecialOnChange() {
            $('.filter_select_special').on("ready change", function() {
              submitDrupalForm();
            });
          }

          function submitDrupalForm() {
            var selected = $(".filter_select_special :selected").text();
            let mha = $('article > .category-mha').length !== 0 ?? false;
            // console.log("SELECTED: " + selected);
            var location = selected.split(" - ")[0];
            var type = selected.split(" - ")[1];
            let viewName = "trends_chart_cancer_special";
            if (mha) {
              viewName = "trends_chart_mha";
            }
            // console.log("viewName: " + viewName);
            var drupalFormLocation = $('.view-display-id-' + viewName + ' .form-item-title input');
            var drupalFormType =  $('.view-display-id-' + viewName + ' .form-item-title-1 input');

            if (location != drupalFormLocation.val() || type != drupalFormType.val()) {
              $('.view-display-id-' + viewName + ' .form-item-title input').val(location);
              $('.view-display-id-' + viewName + ' .form-item-title-1 input').val(type);

              $('.view-display-id-' + viewName + ' .js-form-submit').click();
            }
          }

          $(document).on('ajaxComplete', cancerSpecialOnChange());


            $('table').each(function() {
              var collapseButtons = $(this).find('.waittime-collapsible-parent button');
              collapsingTable(collapseButtons, $(this));
            });

          $('#waittimes-lc-volume .days-suffix').text('people');
          $('#waittimes-lc-volume th.views-field-field-wait-time-wait-time').text('Wait List');

          // multiple table filtering in nested tabs for
          // display on procedure pages
          function WaittimesTableFilter(controlContainer) {

            var data_parent_filter;
            var target_panel;
            var filter_select, wrapped_filter_select;
            var filter, wrapped_filter;
            var controls;

            (function init(){

              filter_select = $("<select class='filter_select form-control form-item form-select table-filter-select'></select>")
                .data('tableFilterableTable', $(this));

              filter = $("<select class='filter form-control form-item form-select table-filter' options=''></select>")
                .data('tableFilterableTable', $(this))
                .hide();

              // Wrappers for IE9 and below support.
              wrapped_filter_select = $("<div class='select-wrapper'>")
                .append(filter_select);

              wrapped_filter = $("<div class='select-wrapper'>")
                .append(filter);

              controls = $("<div class='table-filterable-filters'/>")
                .append(wrapped_filter_select, wrapped_filter);

              $(controlContainer)
                .html(controls);

              filter_select
                .change(function(){
                  if( $(this).val() != "all" ){

                    data_parent_filter = $(this).val();
                    var list = [];

                    filter
                      .html("")
                      .append("<option value='all'>All</option>");

                      var active_tab_id = $('.ui-tabs-active')[0].getAttribute('aria-controls');
                      var search = '#' + active_tab_id + " table";
                      var table = $(search);
                      var query = 'tr:not(".subfacility") td.' + data_parent_filter;
                      var tds = table.find(query);

                      tds.each(function(){

                      var text = $.trim($(this).text());

                      if( text != "" && (list.indexOf(text) == -1) ){
                        filter.append('<option data-filter="'+data_parent_filter+'" value="'+text+'">'+text+"</option>");
                        list.push(text);
                      }

                    });

                    filter.show();

                  }else{

                    reset_filter();

                  }

                });

              filter.change(function(){
                  filter_tables(target_panel,$(this).val());
                });
            })();

            function set_panel(panel){
              target_panel = panel;

              if( panel.find(".view-display-id-trends_chart").length != 0 || panel.find(".view-display-id-trends_chart_lc50").length != 0 || panel.find(".view-display-id-trends_chart_cancer_special").length != 0 || panel.find(".view-display-id-trends_chart_lcwl").length != 0 || panel.find(".view-display-id-trends_chart_mha").length != 0 ){

                  // trending tab activated
                  controls.hide();
                  $('.filter_select_special').show();


              }else{

                  // table tab activated
                  var tables = $('table');
                  if( tables.length ){
                    controls.show();
                    $('.filter_select_special').hide();
                    update_filters( panel );
                  }else{
                    controls.hide();
                  }
              }
            }

            function update_filters(panel){
                filter_select
                  .html("")
                  .append("<option value='all'>All Results</option>");

                // Grab list of filters from table headers, exclude unfilterable
                panel.find("table").first().find('th').each(function(){

                  data_parent_filter = $.trim($(this).text().split(" ")[0]);

                  var do_not_filter = ['Consult', 'Surgery', 'Wait', '50th', '90th'];

                  if (!do_not_filter.includes(data_parent_filter)) {
                    var target_class = $(this).attr('class').match(/views-field-(.*?)(?=\s|$)/g);
                    if( target_class && target_class.length > 0 ){
                      filter_select.append("<option value='"+target_class[0]+"'>"+data_parent_filter+"</option>");
                    }
                  }
                });
                reset_filter();

            }

            function refilter(){
              var filter_value = "td." + filter.find(":selected").attr("data-filter");
              filter_tables(target_panel, filter_value);
            }

            function reset_filter(){
                filter_tables(target_panel, 'all');

                filter_select
                  .show();

                filter
                  .html("")
                  .hide();

            }

            function filter_tables(panel, value){
                var filter_value = value;
                if( filter_value != "all" ){

                  var selector = "td." + filter.find(":selected").attr("data-filter");

                  $("tbody tr", panel).hide();

                  if ($('.waittime-collapsible-parent').length > 0) {
                    $("tbody tr.data-filterable", panel)
                    .each(function(){
                      if( $.trim($(this).find(selector).text()) == filter_value && $(this).hasClass('waittime-collapsible-parent')){
                        $(this).show();
                      }
                    });
                  }

                  else {
                    $("tbody tr.data-filterable")
                    .each(function(){
                      if( $.trim($(this).find(selector).text()) == filter_value){
                        $(this).show();
                      }
                    });
                  }

                }else{

                  $("tbody tr:not('.subfacility').data-filterable", panel).show();
                }
                stripeRows($("tbody tr:visible:not('.subfacility')"));
            }

            return {
              'set_panel' : set_panel,
              'update_filters' : update_filters,
              'filter_tables' : filter_tables,
              'refilter' : refilter
            };
          }

            if(context == document){

              $('.waittimes-content').each(function(){

                var view = $(this);
                var controls = view.find('.table-filterable-control');

                var waittimesTableFilter = new WaittimesTableFilter( controls );

                // adjust table filters and period view when switching tabs
                view.find('.outer-tabs').on("tabscreate tabsactivate",
                    function(event, ui){

                        if( $(event.target).is('.outer-tabs') ){
                            var panel = (typeof ui.newPanel != 'undefined')?ui.newPanel:ui.panel;
                            waittimesTableFilter.set_panel(panel);
                        }

                        if( $('#waittimes-panel-waittimes-volume:visible').length ) {
                            $('.field-name-field-volume-period').show();
                            $('.field-name-field-period').hide();
                        }
                        else {
                            $('.field-name-field-volume-period').hide();
                            $('.field-name-field-period').show();
                        }
                    });
              });

            }else{
              var view = $(this);

              var controls = view.find('.table-filterable-control');
                // ajax refresh
              var waittimesTableFilter = new WaittimesTableFilter( controls );
              waittimesTableFilter.refilter();
            }

            function trendsLegend() {

              const trendsChart = document.querySelector('.charts-highchart');
              const chartLegend = document.querySelector('.highcharts-legend');
              const trendsTable = document.querySelector('.view-display-id-trends_procedure_table_attachment');

              if (trendsTable && chartLegend) {
                for (let i = 0; i <= 5; i++) {
                  if (i === 0) {
                    if (trendsTable.querySelectorAll('.views-field-field-wait-time-data-section').length == 0) {
                      chartLegend.querySelector('.highcharts-legend-item.highcharts-series-' + i).classList.add('highcharts-legend-item-disabled');
                    }
                  } else {
                    if (trendsTable.querySelectorAll('.views-field-field-wait-time-data-section-' + i).length == 0) {
                      chartLegend.querySelector('.highcharts-legend-item.highcharts-series-' + i).classList.add('highcharts-legend-item-disabled');
                    }
                  }
                }
              }
            }

            if ($(".charts-highchart").length) {
              trendsLegend();
            }
          });
        }
      };

    function markupTabs(element){
      var tabIndex = 0;
      var tabs = '<ul>';
      element.find('> .tab').each(function() {
        tabs = tabs + '<li><a href="#' + $(this).attr('id') + '" ' +
            'uitabindex="'+ tabIndex + '" ' +
            'hash="#'+ $(this).attr('id') + '"><span>' +
            $(this).find('> h2').text() + '</span></a></li>';
        $(this).find('> h2').hide();
        tabIndex = tabIndex + 1;
      });
      tabs = tabs + '</ul>';
      return $(tabs);
    }

    // Tabs for panes such as the search panel
    Drupal.behaviors.tabs = {
      attach: function (context, settings) {{
        once('tabs', 'html', context).forEach(function(element) {
        var content = $('.waittimes-content');
        if(context == document){
          // inital page load

          $('.outer-tabs').each(function() {

            var options = {};
            var outerTabs = $(this);
            var tabs = markupTabs(outerTabs);

            // use url hash to preselect tabs ( used with sorting )
            var t = location.hash;
            // If the hash does not contain 'trends', we will use the beginning of the hash for the tab.
            // e.g. #waittimes-90 will use #waittimes tab
            // else, tabs will use the full hash (e.g. #trends-vol) to select the tab.
            if (!t.includes('trends')) {
              t = location.hash.split("-")[0];
            }
            options.active = Number(tabs.find("a[hash='"+t+"']").attr("uitabindex"));

            $(this).prepend(tabs).tabs(options);
            tabs.find('li a').addClass('btn');
          });

          $('.inner-tabs').each(function() {

            var options = {};
            var tabs = markupTabs($(this));

            // use url hash to preselect tabs ( used with sorting )
            var t = location.hash;
            options.active = Number(tabs.find("a[hash='"+t+"']").attr("uitabindex"));

            $(this)
              .prepend(tabs)
              .tabs(options);
          });

          $('.outer-tabs > .ui-tabs-nav').each(function() {
            $(this).find('> li').first().addClass('first');
            $(this).find('> li').last().addClass('last');
          });

          // add hashes to table links
          content.find("a[hash]").click(function(e){
            e.preventDefault();
            // location.hash = $(this).attr("hash");
            history.replaceState(null,null,$(this).attr("hash"));
          });

          add_hash_sort_link_hashes(content);

          // unhide content now that we have formatted it
          content.show();

        }else{

            //ajax refesh
            add_hash_sort_link_hashes(content);
        }

        function add_hash_sort_link_hashes(content){

          // this could be optimized
          content.find(".tab-waittimes-90 th a").not('[href*="#"]').each(function(){
            $(this).attr("href", $(this).attr("href")+"#waittimes-90");
            $(this).attr("historypush", "true");
          });
          content.find(".tab-waittimes-50 th a").not('[href*="#"]').each(function(){
            $(this).attr("href", $(this).attr("href")+"#waittimes-50");
            $(this).attr("historypush", "true");
          });
          content.find(".tab-surgeons-90 th a").not('[href*="#"]').each(function(){
            $(this).attr("href", $(this).attr("href")+"#surgeons-90");
            $(this).attr("historypush", "true");
          });
          content.find(".tab-surgeons-50 th a").not('[href*="#"]').each(function(){
            $(this).attr("href", $(this).attr("href")+"#surgeons-50");
            $(this).attr("historypush", "true");
          });

          content.find("a[historypush]").click(function(e){
            e.preventDefault();
            history.pushState(null, null, $(this).attr("href"));
          });
        }
      });
      }}
    };

    // Trimmed ( Hidden ) Text
    Drupal.behaviors.TrimmedHidden = {
      attach: function (context, settings) {
        $('.show-more').on('load click', function() {
          if ($(this).attr('aria-expanded') == 'true') {
            $(this).text('show less');
          }
          else {
            $(this).text('show more');
          }
        });
      }
    };

})(jQuery, Drupal, once, this);
